<template>
  <div class="p-6 mt-10 bg-white shadow-md">
    <recorder @mediaReady="onMediaReady" @cancel="showRecorder = false" v-if="showRecorder"></recorder>

    <h2 class="mb-6 text-xl text-center">{{ __("Media") }}</h2>
    <div class="relative flex flex-wrap justify-center sm:flex-nowrap" :class="{'sm:h-128': playerMedia}">
      <div class="relative w-full mb-6 sm:mb-0 sm:flex-1 sm:mr-6" v-if="jobMedia.length">
        <div class="absolute top-0 left-0 z-10 px-2 py-1 text-sm text-white bg-gray-500">{{ playerMedia.created_at }}</div>
        <img v-if="playerMedia && playerMedia.collection_name === 'images'" :src="playerMedia.url" alt="" class="inset-0 object-contain w-full h-full bg-black"/>

        <video v-if="playerMedia && playerMedia.collection_name === 'videos'" class="inset-0 object-contain w-full h-full bg-black" controls :key="playerMedia.id">
          <source :src="playerMedia.url" type="video/webm">
          <source :src="playerMedia.url_mp4" type="video/mp4">
        </video>
      </div>

      <div class="flex flex-col w-full overflow-hidden sm:w-64 sm:h-full">

        <button class="w-full h-12 px-4 mb-5 font-semibold text-white rounded-md bg-coral-400" :disabled="!job.permissions.editJobFiles" @click="showRecorder = true" v-if="editable && !isSafari() && isMobile">
          {{ __("Add media") }}
        </button>

        <form class="flex flex-col items-center flex-shrink-0 mb-6" @submit.prevent="submit" v-if="editable && (isSafari() || !isMobile)">
          <media-input v-model="form.media" :loading="submittingForm" :disabled="!job.permissions.editJobFiles" class="w-full" type="file"></media-input>
          <div v-if="validationError('jobFile')" class="mt-2 text-red-500">{{ validationError('jobFile') }}</div>
        </form>

        <div class="overflow-y-scroll min-h-64 sm:h-128 sm:flex-shrink-0 sm:flex-1" v-if="jobMedia.length">
          <div class="relative flex-shrink-0 w-full h-40 mb-3" v-for="media in jobMedia" @click="viewMedia(media)">
            <div class="absolute bottom-0 left-0 z-10 px-2 py-1 text-sm text-white bg-gray-500">{{ media.created_at }} <span v-if="media.collection_name === 'videos' && !media.processed_at">- processing...</span></div>
            <loading-button v-if="editable"
                            :loading="deletingMediaId === media.id"
                            :disabled="!job.permissions.editJobFiles || (media.collection_name === 'videos' && !media.processed_at)"
                            @click="deleteMedia(media)"
                            class="absolute top-0 right-0 z-10 px-2 py-1 text-sm text-white bg-coral-400">
              {{ __("Delete") }}
            </loading-button>
            <img :src="media.url_thumb" alt="" class="inset-0 object-contain w-full h-full bg-black cursor-pointer" :key="media.processed_at">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MediaInput from '@/Shared/MediaInput';
  import Recorder from "../../Shared/Recorder";
  import LoadingButton from "../../Shared/LoadingButton";

  export default {
    props: {
      job: Object,
      editable: Boolean
    },
    components: {
      LoadingButton,
      MediaInput,
      Recorder
    },
    data() {
      return {
        deletingMediaId: null,
        showRecorder: false,
        submittingForm: false,
        form: {
          media: null
        },
        playerMedia: null
      }
    },
    methods: {
      viewMedia(media) {
        this.playerMedia = media;
      },
      deleteMedia(media) {
        if (confirm(this.__("Are you sure you want to delete this file?"))) {
          this.deletingMediaId = media.id;
          this.$inertia.delete(this.route('jobfiles.destroy', {job: this.job.id, file: media.id}), {
            preserveScroll: true
          });
        }
      },
      submit() {
        this.submittingForm = true;

        let data = new FormData();
        data.append('jobFile', this.form.media || '');
        this.$emit('uploading');
        this.$inertia.post(this.route('jobfiles.store', {job: this.job.id}), data, {
          preserveScroll: true
        }).finally(() => {
          this.submittingForm = false;
          this.form.media = null;
          this.$emit('finished');
        })
      },
      onMediaReady(file, name) {
        let formData = new FormData();
        if (name) {
          formData.append('jobFile', file, name);
        } else {
          formData.append('jobFile', file);
        }
        this.$emit('uploading');

        this.$inertia.post(this.route('jobfiles.store', {job: this.job.id}), formData, {
          preserveScroll: true,
          preserveState: false,
        }).then(() => {
          this.$emit('finished');
        });
      }
    },
    computed: {
      isMobile() {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      },
      jobMedia() {
        return this.job.media.filter((media, index) => {
          if (index === 0) {
            this.viewMedia(this.job.media[0]);
          }
          return media;
        });
      }
    }
  }
</script>
